import script from "./TimetableSailing.vue?vue&type=script&setup=true&lang=ts"
export * from "./TimetableSailing.vue?vue&type=script&setup=true&lang=ts"

import "./TimetableSailing.vue?vue&type=style&index=0&id=5958e02d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5958e02d"]])

export default __exports__